import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const ambitos = [
  { id: 1, nombre: "ATENCIÓN HOSPITALARIA" },
  { id: 2, nombre: "ATENCIÓN PRIMARIA" },
  { id: 5, nombre: "CENTRO ESCOLAR" },
  { id: 6, nombre: "CENTRO HEMOTERAPIA" },
  { id: 8, nombre: "CLÍNICA PRIVADA" },
  { id: 9, nombre: "EMERGENCIAS" },
  { id: 3, nombre: "GERENCIA REGIONAL SALUD (ADMIN)" },
  { id: 12, nombre: "JUBILADO" },
  { id: 10, nombre: "OTROS" },
  { id: 11, nombre: "PARADO" },
  { id: 4, nombre: "RESIDENCIA MAYORES" },
  { id: 7, nombre: "SERVICIO PREVENCIÓN/MUTUA" },
];

const SelectAmbitoTrabajo = ({ name, value, onChange }) => (
  <FormControl fullWidth>
    <InputLabel id={`${name}-label`}>Ámbito de Trabajo</InputLabel>
    <Select
      labelId={`${name}-label`}
      name={name}
      value={value}
      onChange={onChange}
    >
      <MenuItem value="">Ninguno</MenuItem>
      {ambitos.map((a) => (
        <MenuItem key={a.id} value={a.id}>
          {a.nombre}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default SelectAmbitoTrabajo;
